import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { searchFailure, searchSuccess, searchTags } from './actions';
import { TagInputStoreSlice, RequestStatus } from './types';

const reducers = handleActions<TagInputStoreSlice, any>(
  {
    [searchTags.toString()]: state => ({
      ...state,
      searchRequestStatus: RequestStatus.Processing,
    }),
    [searchSuccess.toString()]: (
      state,
      action: ReturnType<typeof searchSuccess>
    ) => ({
      ...state,
      tagSearchResults: action.payload.tags,
      searchRequestStatus: RequestStatus.Success,
    }),
    [searchFailure.toString()]: state => ({
      ...state,
      tagSearchResults: [],
      searchRequestStatus: RequestStatus.Failure,
    }),
  },
  {
    tagSearchResults: [],
    searchRequestStatus: RequestStatus.Success,
  }
);

export default { [reduxKey]: reducers };
